import { Injectable, inject } from '@angular/core';
import { combineLatest, catchError, of, switchMap, take, Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { ReportGroupFilterListingService } from 'src/app/services/api/report-group-filter/report-group-filter-listing.service';
import { translationKeysMap } from 'src/app/services/translate/translate.key-mapper';
import {
  COMMODITIES,
  DEVICE_TYPE,
  REQUEST_PROCESSING_DATE_TIME,
  COMMAND_STATUS,
  BOARD_TYPE,
  SLOT,
  COMMAND,
  REQUEST_PROCESSING_SCHEDULED_DATE_TIME,
  REQUEST_PROCESSING_START_DATE_TIME
} from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import {
  FilterModel,
  FilterModels,
  ListingFiltersSource
} from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import {
  isSingleCommodityClient,
  selectCommodities
} from 'src/app/pages/help-and-settings/user-settings/store/user-settings.reducer';

@Injectable()
export class RequestProcessingListingFiltersSourceService implements ListingFiltersSource {
  private readonly store = inject(Store);
  readonly reportGroupFilterService = inject(ReportGroupFilterListingService);
  readonly #isSingleCommodityClient = this.store.selectSignal(isSingleCommodityClient);

  readonly #applicable = 'AMI Health Dashboard';

  private getCommandFilter(): FilterModel {
    return {
      ...COMMAND,
      // Let translatedFilters() sort by currently selected language.
      isNonSortable: false,
      items: [...COMMAND.items],
      selected: [...COMMAND.selected]
    };
  }

  getAll(): Observable<FilterModels> {
    return combineLatest([this.store.select(selectCommodities).pipe(take(1)), this.getReportGroup()]).pipe(
      switchMap(([commoditiesItems, reportGroupFilter]) => {
        const commoditiesMultiselectItems = commoditiesItems.map(item => ({
          text: translationKeysMap.get(item) || item,
          value: item
        }));
        const commoditiesFilter: FilterModel = {
          ...COMMODITIES,
          items: commoditiesMultiselectItems,
          selected: commoditiesMultiselectItems,
          width: 160
        };
        const commandFilter = this.getCommandFilter();

        return of([
          reportGroupFilter,
          DEVICE_TYPE,
          ...(this.#isSingleCommodityClient() ? [] : [commoditiesFilter]),
          commandFilter,
          COMMAND_STATUS,
          REQUEST_PROCESSING_SCHEDULED_DATE_TIME,
          REQUEST_PROCESSING_START_DATE_TIME,
          BOARD_TYPE,
          SLOT,
          REQUEST_PROCESSING_DATE_TIME
        ]);
      }),
      catchError(error => {
        return of(error);
      })
    );
  }

  getReportGroup(): Observable<FilterModel> {
    return this.reportGroupFilterService.getFilter(this.#applicable);
  }
}
